const Progress = ({ value }) => {
  return (
    <div className="progress">
      <span className="progress--line" style={{ width: `${value}%` }}></span>
    </div>
  );
};

export default Progress;
